
import React, { useState, useEffect, useRef } from "react";
import { Modal } from 'carbon-components-react';
//import ReactBpmn from "react-bpmn";
//import BpmnJS from "bpmn-js";
import BpmnNavigatedViewer from 'bpmn-js/dist/bpmn-navigated-viewer.development.js';
import callGetApi from "../../requests/GetRequests";
import * as Constants from '../../requests/URLConstants';
import callPostApi from "../../requests/PostRequests";
import * as DashboardConstants from '../Dashboards/DashboardConstants';
import BusinessAnomaly from 'assets/image/business-anamoly.svg';
import Settings from 'assets/image/settings.svg';
import ITanamoly from 'assets/image/server.svg';
import ChevronRight from 'assets/image/chevron--right.svg';
import ChevronLeft from 'assets/image/chevron--left.svg';
import Close32 from 'assets/image/close.svg';
import Database from 'assets/image/Database.svg';
import Warning from 'assets/image/warning.svg';
import LeftArrow from 'assets/image/arrow--left.svg';
import WeatherIcon from 'assets/image/weatherIcon.svg';
import Time from 'assets/image/time32.svg';
import BpmnSummary from './BpmnSummary';
import InlineLoading from 'carbon-components-react/lib/components/InlineLoading';
import { Maximize32, Subtract32, Add32, Reset32 } from '@carbon/icons-react';
import * as mockdata from './transactionMockdata.json'
import "@carbon/charts/styles.css";
import { LineChart } from "@carbon/charts";
import $ from 'jquery';
import * as workspaces from '../../config/WorkspaceConstants';
import * as mockSettingsData from './mockDataForSetting';
import BpmnTableComponent from './BpmnTableComponent';
import BPMNSideNav from "./BPMNSideNav";
var moment = require('moment');

require('./diagram.scss');


const BpmnDiagram = props => {
    const defaultFirstRowIndex = 0;
    const defaultCurrentPageSize = props.defaultCurrentPageSize || 5;
    const defaultNextPageIndex = 1;
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [firstRowIndex, setFirstRowIndex] = useState(defaultFirstRowIndex);
    const [pageSize, setPageSize] = useState();
    const [selectedNextPageIndex, setSelectedNextPageIndex] = useState('1');
    const [alertsStartingIndex, setAlertsStartingIndex] = useState();
    const [openedTableCells, setOpenedTableCells] = useState([]);
    const [sqlQueriesData, setSqlQueriesData] = useState([]);
    const [loader, setloader] = useState(false);
    const [alertType, setAlertType] = useState();
    const [impactArray, setimpactArray] = useState(false);
    const [SalesOrderBookedValue, setSalesOrderBookedValue] = useState(0);
    const [SalesOrderIntakeValue, setSalesOrderIntakeValue] = useState(0);
    const [SummaryDropdown, setSummaryDropdown] = useState('FinanceReporting');
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [settingsModalContent, setSettingsModalContent] = useState();
    const [itAnomalyR, setItanomalyR] = useState([]);
    const [itAnomalyA, setItanomalyA] = useState([]);
    const [applicationAlerts, setApplicationAlerts] = useState([]);
    const [systemAlerts, setSystemAlerts] = useState([]);
    const [activeElement,setActiveElement] = useState();
    const [ovr, setOvr] = useState({});
    const [cl, setCl] = useState();
    const SalesOrderBookedImpact = useRef(0);
    const SalesOrderIntakeImpact = useRef(0);
    const SalesOrderBookedValueforGraph = useRef(0);
    const SalesOrderIntakeValueforGraph = useRef(0);


    useEffect(() => {
        getPaginatedRows();
    },[applicationAlerts, systemAlerts, alertType, activeElement]);

    useEffect(() => {
        SalesOrderBookedValueforGraph.current = SalesOrderBookedValue;
        SalesOrderIntakeValueforGraph.current = SalesOrderIntakeValue;
    }, [SalesOrderBookedValue, SalesOrderIntakeValue])

    useEffect(() => {
        if (ovr && itAnomalyR.length && itAnomalyA.length && cl && paginatedRows)
        if(SummaryDropdown === "FinanceReporting") {
            if(alertType === 'application') {
                displaySettings(ovr, itAnomalyR, itAnomalyA, cl, paginatedRows, pageSize, alertType);
            }
            else {
                displaySystemAlerts(ovr, itAnomalyR, itAnomalyA, cl, paginatedRows, pageSize, alertType);
            }
        }
    }, [SummaryDropdown, ovr, itAnomalyR, itAnomalyA, cl, paginatedRows, pageSize, firstRowIndex, selectedNextPageIndex, alertType])

    const prepareAlerts = (resp) => {
        let applicationAlerts = [];
        let systemAlerts = [];
        let bobi = 0, bw = 0, hana = 0, s4Hana = 0;
        for (let i = 0; i < resp.length; i++) {
            if (resp[i].alertType === 'application') {
                if (resp[i] && resp[i].transactionSteps) {
                    bobi = (resp[i].transactionSteps.find(o => o.transactionStep === 'BOBI')) && resp[i].transactionSteps.find(o => o.transactionStep === 'BOBI').duration ? (resp[i].transactionSteps.find(o => o.transactionStep === 'BOBI').duration) : 0
                    bw = (resp[i].transactionSteps.find(o => o.transactionStep === 'BW')) && resp[i].transactionSteps.find(o => o.transactionStep === 'BW').duration ? (resp[i].transactionSteps.find(o => o.transactionStep === 'BW').duration) : 0;
                    hana = (resp[i].transactionSteps.find(o => o.transactionStep === 'E_HANA')) && resp[i].transactionSteps.find(o => o.transactionStep === 'E_HANA').duration ? (resp[i].transactionSteps.find(o => o.transactionStep === 'E_HANA').duration) : 0;
                    s4Hana = (resp[i].transactionSteps.find(o => o.transactionStep === 'S/4 HANA')) && resp[i].transactionSteps.find(o => o.transactionStep === 'S/4 HANA').duration ? (resp[i].transactionSteps.find(o => o.transactionStep === 'S/4 HANA').duration) : 0;
                }
                let offset = moment(resp[i].alertTime).utcOffset(),
                    obj = {
                        id: (i + 1).toString(),
                        alertType: resp[i].alertType || '-',
                        alertName: resp[i].alertName || '-',
                        reportName: resp[i].details && resp[i].details.find(o => o.name === 'reportName') && resp[i].details.find(o => o.name === 'reportName').value ? resp[i].details.find(o => o.name === 'reportName').value : "-",
                        username: resp[i].details && resp[i].details.find(o => o.name === 'userName') && resp[i].details.find(o => o.name === 'userName').value ? resp[i].details.find(o => o.name === 'userName').value : '-',
                        incidentNumber: resp[i].incident ? resp[i].incident.number : '-',
                        timestamp: resp[i].alertTime ? moment(resp[i].alertTime).utcOffset(offset).format('YYYY-MM-DD HH:mm') : '-',
                        bobi: bobi ? Number(bobi).toFixed(2) + ' secs' : '0 sec',
                        bw: bw ? Number(bw).toFixed(2) + ' secs' : '0 sec',
                        hana: hana ? Number(hana).toFixed(2) + ' secs' : '0 sec',
                        s4Hana: s4Hana ? Number(s4Hana).toFixed(2) + ' secs' : '0 sec',
                        total: Number(bobi || 0) ? Number(bobi || 0) : Number(bw || 0) ,
                        queryPrompts: resp[i].queryParams ? JSON.stringify(resp[i].queryParams) : 'No data available',
                        activityID: resp[i].activityId ? resp[i].activityId : '-',
                        incidentSysId: resp[i].incident ? resp[i].incident.sysId : '-',
                        sqlQueriesData: resp[i].remoteStatements ? resp[i].remoteStatements : '-',
                    }
                applicationAlerts.push(obj);
            } else {
                let offset = moment(resp[i].alertTime).utcOffset(),
                    obj = {
                        id: (i + 1).toString(),
                        alertType: resp[i].alertType || '-',
                        alertName: resp[i].alertName || '-',
                        incidentNumber: resp[i].incident ? resp[i].incident.number : '-',
                        timestamp: resp[i].alertTime ? moment(resp[i].alertTime).utcOffset(offset).format('YYYY-MM-DD HH:mm') : '-',
                        activityID: resp[i].activityId || '-',
                        description: resp[i].description || '-',
                        incidentSysId: resp[i].incident ? resp[i].incident.sysId : '-'
                    }
                systemAlerts.push(obj);
            }
        }
        return { applicationAlerts, systemAlerts };
    };

    const addUniqueId = (rows) => {
        for(let i = 0; i < rows.length; i++) {
            rows[i].id = i+1;
        }
        return rows;
    }
    const getBpmnAlerts = (filters) => {
        setloader(true);
        let bodyJSON = {
            reportType: filters.bpmn_report_type ? filters.bpmn_report_type : [],
            reportName: filters.bpmn_report ? filters.bpmn_report : [],
            userName: filters.bpmn_user ? filters.bpmn_user : []
        }
        let formattedData = [];
        return callPostApi(Constants.GETBPMNALERTS, { 'Content-Type': 'application/json' }, bodyJSON)
            .then(resp => {
                setloader(false);
                formattedData = prepareAlerts(resp);
                setApplicationAlerts(formattedData.applicationAlerts);
                setSystemAlerts(formattedData.systemAlerts);
                return formattedData ? formattedData : [];
            });
    }
    const fetchDiagram = (url, summary) => {
        setloader(true);
        let body = { 'processName': summary };
        return callPostApi(url, { 'Content-Type': 'application/json' }, body).then(result => {
            //console.log("xml", result);
            let DocData; let ITAnamolyArray = []; let BusinessAnamolyArray = []; let OverlayMappingArray = []; let Client;
            if (SummaryDropdown === 'FinanceReporting') {
                DocData = mockdata.doc;
                ITAnamolyArray = mockdata.ITanomalyData;
                BusinessAnamolyArray = mockdata.BusinessanomalyData;
                OverlayMappingArray = mockdata.OverlayMapping;
                Client = mockdata.PartyName;
            }
            else {
                DocData = result.doc;
                ITAnamolyArray = result.ITanomalyData;
                BusinessAnamolyArray = result.BusinessanomalyData;
                OverlayMappingArray = result.OverlayMapping;
                Client = result.PartyName;
            }
            const array1 = ITAnamolyArray.filter(result => result.Impact !== "NA").concat(BusinessAnamolyArray.filter(result => result.Impact !== "NA"))
            const arrayUniqueByIncident = [...new Map(array1.map(item => [item['IncidentNumber'], item])).values()]; // removing duplicate incident data
            var holder = {}; var ImpactArraydata = [];
            arrayUniqueByIncident.forEach(function (d) {
                let impact = d.Impact && d.Impact !== "NA" && d.Impact !== null ? d.Impact : 0;
                if (holder.hasOwnProperty(d.ImpactedKPI)) {
                    holder[d.ImpactedKPI] = parseFloat(holder[d.ImpactedKPI]) + parseFloat(impact)
                } else {
                    holder[d.ImpactedKPI] = parseFloat(impact);
                }
            });

            for (var prop in holder) {
                ImpactArraydata.push({ ImpactedKPI: prop, Impact: holder[prop] });
            }
            setimpactArray(ImpactArraydata);

            setloader(false);
            return { DocData, ITAnamolyArray, BusinessAnamolyArray, OverlayMappingArray, Client };
        }).catch((error) => {
            setloader(false);
        });
    }
    let zoomlevel = 1;

    const handleZoomIn = (canvas) => {
        if (zoomlevel === 1 || zoomlevel <= 1.5) {
            zoomlevel = zoomlevel + 0.03
            canvas.zoom(zoomlevel.toPrecision(3));
            // document.getElementById("bpmnContainer").style.height = `${document.getElementById("bpmnContainer").offsetHeight + 15}px`;
        }
    }
    const handleZoomOut = (canvas) => {
        if (zoomlevel >= 0.6) {
            zoomlevel = zoomlevel - 0.03
            canvas.zoom(zoomlevel.toPrecision(3));
            // document.getElementById("bpmnContainer").style.height = `${document.getElementById("bpmnContainer").offsetHeight - 15}px`;
        }
    }
    const handleZoomReset = (canvas) => {
        zoomlevel = 1
        canvas.zoom(1);
        canvas.zoom('fit-viewport', 'auto');
        //document.getElementById("bpmnContainer").style.height = `1050px`;
    }


    useEffect(() => {
        async function fetchXML() {
            const url = "";
            const BPMNData = await fetchDiagram(url, SummaryDropdown);
            let alertsData = [];
            let isInitiateStatementApplicationAlertExist = [];
            let isInitiateStatementSystemAlertExist = [];
            let isExecuteQueryStatementExist = [];
            let systemAlerts = [];
            let systemResult = []
            let SettingsArray = [];
            let SettingsResult = [];
            if(SummaryDropdown === "FinanceReporting") {
                alertsData = await getBpmnAlerts(props.filterSelectionsSAP);
                systemAlerts = alertsData.systemAlerts;
                SettingsArray = alertsData.applicationAlerts;
                SettingsResult = SettingsArray.map((result, i) => ({ activityID: result.activityID, id: i }))
                systemResult = systemAlerts.map((result, i) => ({ activityID: result.activityID, id: i }))
            }
            const diagram = BPMNData ? BPMNData.DocData : null;
            var viewer = new BpmnNavigatedViewer({
                // container: '#bpmnContainer', additionalModules: [{ moveCanvas: ['value', ''] }]
                container: '#bpmnContainer', additionalModules: [{ moveCanvas: ['value', ''], zoomScroll: [ 'value', '' ]}]
            });
            var canvas = viewer.get('canvas'), overlays = viewer.get('overlays');
            diagram && viewer.importXML(diagram, function (err) {
                // zoom to fit full viewport
                canvas.zoom(1);
                canvas.zoom('fit-viewport', 'auto');
                document.getElementById("btnzoomin").onclick = () => { handleZoomIn(canvas) };
                document.getElementById("btnzoomout").onclick = () => handleZoomOut(canvas);
                document.getElementById("btnzoomreset").onclick = () => handleZoomReset(canvas);

                //Dummy data
                //var ITAnamolyResult = tables.OverlayMapping.filter(result => result.ITAnamoly === "yes").map(value => value.ActivityID)
                //var BusinessAnamolyResult = tables.OverlayMapping.filter(result => result.BusinessAnamoly === "yes").map(value => value.ActivityID)
                // addBusinessAnamoly(overlays, BusinessAnamolyResult, tables.BusinessanomalyData);
                // addITAnamoly(overlays, ITAnamolyResult, tables.ITanomalyData);

                //Actual data
                if (SummaryDropdown !== "FinanceReporting") {
                    let BusinessAnamolyArray = BPMNData.BusinessAnamolyArray.filter(result => result.Impact !== "NA")
                    let ITAnamolyArray = BPMNData.ITAnamolyArray.filter(result => result.Impact !== "NA");
                    let ITAnamolyResult = ITAnamolyArray.map(result => ({ activityID: result.ActivityID, id: result.id }))
                    let BusinessAnamolyResult = BusinessAnamolyArray.map(result => ({ activityID: result.ActivityID, id: result.id }))
                    let Client = BPMNData.Client ? BPMNData.Client : '';
                    addBusinessAnamoly(overlays, BusinessAnamolyResult, BusinessAnamolyArray, Client); //to add business anamoly icon
                    addITAnamoly(overlays, ITAnamolyResult, ITAnamolyArray, Client); //to add IT anamoly icon
                }
                else {
                    let Client = BPMNData.Client ? BPMNData.Client : '';
                    addSettings(overlays, SettingsResult, SettingsArray, Client, 'application');
                    addSystemAlerts(overlays, systemResult, systemAlerts, Client, 'system');
                }
                if (err) {
                    console.log('error rendering', err);
                } else {
                    isInitiateStatementApplicationAlertExist = SettingsResult.filter((o) => o.activityID === 'Activity_0rot5zq');
                    isInitiateStatementSystemAlertExist = systemResult.filter((o) => o.activityID === 'Activity_0rot5zq');
                    isExecuteQueryStatementExist = SettingsResult.filter((o) => o.activityID === 'Activity_0t29nf5');
                    if(isInitiateStatementApplicationAlertExist.length || isInitiateStatementSystemAlertExist.length) {
                        canvas.addMarker('Activity_0rot5zq', 'bpmn-highlight');
                    }
                    if(isExecuteQueryStatementExist.length) {
                        canvas.addMarker('Activity_0t29nf5', 'bpmn-highlight');
                    }
                    console.log('we are good!');
                }
            });
            viewer.get('canvas').zoom('fit-viewport');
        }
        fetchXML()
    }, [SummaryDropdown]);

    useEffect(() => {
        for (var i = 0; i < impactArray.length; i++) {
            if (impactArray[i].ImpactedKPI === "Revenue Booked Sales Orders / day") {
                SalesOrderBookedImpact.current = impactArray[i].Impact
            }
            if (impactArray[i].ImpactedKPI === "Sales Orders Intake / day") {
                SalesOrderIntakeImpact.current = impactArray[i].Impact
            }
        }
    }, [impactArray]);

    function displayCell(cell) {
        let currentHeader = mockSettingsData.mockTableHeaders.filter(function (header) { return header.key === cell.info.header });
        if (!currentHeader[0].optional) {
            return true;
        } else {
            return false;
        }
    }

    const showFullCell = (cellId) => {
        setOpenedTableCells(openedTableCells => [...openedTableCells, cellId]);
    }

    function o(el) {
        var hope = el.parentNode.parentNode.nextElementSibling;
        if (hope.style.display != 'table-row') {
            hope.style.display = 'table-row';
        } else {
            hope.style.display = 'none';
        }
    }
    function toggleSettingsModal(value) {
        setSettingsModalContent(value);
        setShowSettingsModal(!showSettingsModal);
    }
    const getPaginatedRows = async (param, pageSize, element) => {
        let startingIndex = param !== undefined ? Number(param) : firstRowIndex;
        let alerts = [];
        pageSize = pageSize || defaultCurrentPageSize;
        let endIndex = Number(startingIndex) + Number(pageSize);
        setPageSize(pageSize);
        setAlertsStartingIndex(startingIndex);
        let selectedElement = element || activeElement;
        if(alertType === 'application') {
            // alerts = applicationAlerts;
            alerts = applicationAlerts.filter((o) => o.activityID === selectedElement);
        } else {
            // alerts = systemAlerts;
            alerts = systemAlerts.filter((o) => o.activityID === selectedElement);
        }
        let slicedRows = alerts.slice(startingIndex, endIndex);
        await setPaginatedRows(slicedRows);
    }

    const getSqlQuery = (rowId) => {
        let index = Number(rowId);
        let alerts = [];
        if(alertType === 'application') {
            alerts = applicationAlerts;
        } else {
            alerts = systemAlerts;
        }
        let activeRow = alerts[index-1];
        setSqlQueriesData(activeRow.sqlQueriesData ? addUniqueId(activeRow.sqlQueriesData) : []);
    };

    const displaySystemAlerts = (overlays, element, businessArray, Client, slicedRows) => {
        overlays.remove({ type: `IT-Anamolies` })
        overlays.remove({ type: `Business-Anamoly` })
        overlays.remove({ type: `Incident-Hourly-Progression` })
        setActiveElement(element);
        hideBusinessAnomalyDetails(overlays, `system-alerts`);
        overlays.remove({ type: `Incident-Hourly-Progression` })
        var table_array = []
        let rows = slicedRows && slicedRows.length ? slicedRows : paginatedRows;
        let alerts = systemAlerts.filter((o) => o.activityID === element);
        if (element) {
            //to add right arrow
            overlays.add(element, `system-alerts`, {
                position: {
                    top: 0,
                    left: -38
                },
                html: `<div><img class="right-arrow" src=${ChevronLeft} /></div>`
            });
            //to add div for table
            overlays.add(element, `system-alerts`, {
                position: {
                    top: -60,
                    left: -608
                },
                html: `
              <body><div>
              <div class="business-anomalies ${element}" id="business-anomalies ${element}"></div>
              </div></body>  `
            });
            let paginationLength = Math.ceil(alerts.length/Number(pageSize));
            let paginationIndexOptions = [];
            for(let i = 1; i < paginationLength+1; i++) {
                if(selectedNextPageIndex) {
                    if(Number(selectedNextPageIndex) === i) {
                        paginationIndexOptions.push(`<option class="bx--select-option" value=${i} selected>${i}</option>`);
                    } else {
                        paginationIndexOptions.push(`<option class="bx--select-option" value=${i}>${i}</option>`);
                    }
                } else {
                    paginationIndexOptions.push(`<option class="bx--select-option" value=${i}>${i}</option>`);
                }
            }
            let listItems = rows.map(function (value) {
                let incidentpath = `/IncidentDetails?alertType=alert&client=${Client}&incidentId=${value.incidentNumber}&sysId=${value.incidentSysId}&workspace=${workspaces.sap_ops}`;
                return `<tr>
                    <td className="settings-cell"><button class="button-op" data-uid="d1"><img class="right-arrow" src=${ChevronRight} /></button></td>
                    <td class="alert-td">${value.alertName}</td>
                    <td><a href=${incidentpath} target="_blank" >${value.incidentNumber}</a></td>
                    <td class="alert-td">${value.timestamp}</td>
                </tr>
                <tr class="extra-content">
                    <td colspan=${6}>
                        <div class="carbon-display-Regular-12">Description</div>
                        <div>${value.description}</div>
                    </td>
                </tr>`
            }).join('')
            var tablebody = document.getElementById(`business-anomalies ${element}`);
            table_array.push(tablebody)
            let tableData =
                `<div class="incident-tile-container">
                <table class="settings-table">
                    <thead class="carbon-display-Semibold-16">
                        <tr>
                            <th></th>
                            <th>Alert Name</th>
                            <th>Incident #</th>
                            <th>Timestamp</th>
                        </tr/>
                    </thead>
                    <tbody>
                        ${listItems}   
                    </tbody>
                </table>
                <div class="pagination-container">
                    <div class="bx--pagination">
                        <div class="bx--pagination__left">
                            <label id="bx-pagination-select-11-count-label" class="bx--pagination__text" for="bx-pagination-select-11">Items per page</label>
                            <div class="bx--form-item">
                                <div class="bx--select bx--select--inline bx--select__item-count">
                                    <div class="bx--select-input--inline__wrapper">
                                        <div class="bx--select-input__wrapper">
                                            <select id="alert-pageSize" class="bx--select-input">
                                                <option class="bx--select-option" value=${5}>5</option>
                                                <option class="bx--select-option" value=${10}>10</option>
                                                <option class="bx--select-option" value=${15}>15</option>
                                                <option class="bx--select-option" value=${20}>20</option>
                                            </select>
                                            <svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" class="bx--select__arrow" style="user-select: auto;"><path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z" style="user-select: auto;"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="bx--pagination__text bx--pagination__items-count">${alertsStartingIndex+1}–${(Number(alertsStartingIndex)+Number(pageSize-1) > alerts ? alerts.length : (Number(alertsStartingIndex)+Number(pageSize-1) > alerts.length ?  alerts.length : (Number(alertsStartingIndex)+Number(pageSize)))) +' of '+ alerts.length}</span>
                        </div>
                        <div class="bx--pagination__right">
                            <div class="bx--form-item">
                                <div class="bx--select bx--select--inline bx--select__page-number">
                                    <label for="bx-pagination-select-11-right" class="bx--label bx--visually-hidden">Page number, of 10 pages</label>
                                    <div class="bx--select-input--inline__wrapper">
                                        <div class="bx--select-input__wrapper">
                                            <select id="alert-pagination-index" class="bx--select-input">
                                            ${paginationIndexOptions}
                                                
                                            </select>
                                            <svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" class="bx--select__arrow" style="user-select: auto;"><path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z" style="user-select: auto;"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="bx--pagination__text" style="user-select: auto;">of ${paginationLength} pages</span>
                            </div>
                        </div>
                    </div>
                <div>`;
            table_array.map(value => {
                value.innerHTML = `
                    <div class="overlay-container settings-container"><div class="title"><div>${DashboardConstants.Alerts}</div>
                    <div id="close-system-alerts"><img id="close-system-alerts" class="close" src=${Close32} /></div></div>
                   <div class="anomaly-tile">
                   ${tableData}
                   </div>`;
            })
            var pageSizeSelect = document.getElementById("alert-pageSize");
            let selectedPageSize = pageSize ? pageSize.toString() : '5';
            switch(selectedPageSize) {
                case '5':
                    pageSizeSelect && pageSizeSelect.children[0].setAttribute("selected", "selected");
                    break;
                case '10':
                    pageSizeSelect && pageSizeSelect.children[1].setAttribute("selected", "selected");
                    break;
                case '15':
                    pageSizeSelect && pageSizeSelect.children[2].setAttribute("selected", "selected");
                    break;
                case '20':
                    pageSizeSelect && pageSizeSelect.children[3].setAttribute("selected", "selected");
                    break;
                default:
                    pageSizeSelect && pageSizeSelect.children[0].setAttribute("selected", "selected");
                    break;
            }
            //to send impact, incident number, impacted KPI of incident
            let graphdata = businessArray.filter(value => value.ActivityID === element).map(function (value) {
                return ({ incidentNumber: value.IncidentNumber, value: value })
            })
            pageSizeSelect && pageSizeSelect.addEventListener('change', function(e) {
                setPageSize(e.target.value)
                setFirstRowIndex(0);
                getPaginatedRows(0, e.target.value, element);
                setSelectedNextPageIndex(defaultNextPageIndex)
              }, false);
              document.getElementById('alert-pagination-index') &&  document.getElementById('alert-pagination-index').addEventListener('change', function(e) {
                let newFirstRowIndex = pageSize * (e.target.value - 1);
                setFirstRowIndex(newFirstRowIndex);
                setSelectedNextPageIndex(e.target.value);
                getPaginatedRows(newFirstRowIndex, pageSize, element);
              }, false);
            for (let i = 0; i < graphdata.length; i++) {
                var open_incident_div = document.getElementsByClassName(`open-incident-graph-button ${graphdata[i].incidentNumber}`)

                if (open_incident_div) {
                    open_incident_div.onclick = function () {
                        //function call for hourly progression click
                        displayHourlyProgressionData(overlays, element, 'Business-Anamoly', graphdata, graphdata[i].incidentNumber);
                    }
                }
            }
            let infoButtons = document.getElementsByClassName('button-op');
            if (infoButtons.length) {
                for(let i = 0; i < infoButtons.length; i++) {
                    infoButtons[i].onclick = function () {
                        o(infoButtons[i]);
                    }
                }
            }
            let close_business_anomaly = document.getElementById('close-system-alerts');
            if (close_business_anomaly) {
                close_business_anomaly.onclick = function () {
                    //function call to close business anomaly modal
                    hideBusinessAnomalyDetails(overlays, `system-alerts`);
                    setCl(null);
                    setItanomalyR([]);
                    setItanomalyA([]);
                    setOvr({});
                }
            }
        }
    }

    const displaySettings = (overlays, element, businessArray, Client, slicedRows) => {
        setActiveElement(element);
        overlays.remove({ type: `IT-Anamolies` })
        overlays.remove({ type: `Business-Anamoly` })
        overlays.remove({ type: `Incident-Hourly-Progression` })
        // overlays.remove({ type: `system-alerts`})
        hideBusinessAnomalyDetails(overlays, `system-alerts`);
        var table_array = []
        let rows = slicedRows && slicedRows.length ? slicedRows : paginatedRows;
        // rows = rows.filter(function(alert){
        //     return alert.activityID == element;
        // });
        // let alerts = applicationAlerts;
        let alerts = applicationAlerts.filter((o) => o.activityID === element);
        // alerts = applicationAlerts.filter(function(alert){
        //     return alert.activityID == element;
        // });
        if (element) {
            //to add right arrow
            overlays.add(element, `Business-Anamoly`, {
                position: {
                    top: -2,
                    right: -20
                },
                html: `<div><img class="right-arrow" src=${ChevronRight} /></div>`
            });
            //to add div for table
            overlays.add(element, `Business-Anamoly`, {
                position: {
                    top: -60,
                    right: -40
                },
                html: `
              <body><div>
              <div class="business-anomalies ${element}" id="business-anomalies ${element}"></div>
              </div></body>  `
            });
            let paginationLength = Math.ceil(alerts.length/Number(pageSize));
            let paginationIndexOptions = [];
            for(let i = 1; i < paginationLength+1; i++) {
                if(selectedNextPageIndex) {
                    if(Number(selectedNextPageIndex) === i) {
                        paginationIndexOptions.push(`<option class="bx--select-option" value=${i} selected>${i}</option>`);
                    } else {
                        paginationIndexOptions.push(`<option class="bx--select-option" value=${i}>${i}</option>`);
                    }
                } else {
                    paginationIndexOptions.push(`<option class="bx--select-option" value=${i}>${i}</option>`);
                }
            }
            // let paginationIndexOptions = paginationLength.map(function (value) {
            //     return `<option class="bx--select-option" value=${value+1}>${value+1}</option>`
            // });
            let listItems = rows.map(function (value) {
                let incidentpath = `/IncidentDetails?alertType=alert&client=${Client}&incidentId=${value.incidentNumber}&sysId=${value.incidentSysId}&workspace=${workspaces.sap_ops}`
                // let queryPrompts = value.queryPrompts.map(function (query) {
                //     return `<span>${query}</span>`
                // })
                let total = value.total ? Number(value.total).toFixed(2) : 0
                let queryPrompts = `<span>${value.queryPrompts}</span>`;
                return `<tr>
                    <td className="settings-cell"><button class="button-op" data-uid="d1"><img class="right-arrow" src=${ChevronRight} /></button></td>
                    <td class="alert-td">${value.alertName}</td>
                    <td class="alert-td">${value.reportName}</td>
                    <td>${value.username}</td>
                    <td><a href=${incidentpath} target="_blank" >${value.incidentNumber}</a></td>
                    <td class="alert-td">${value.timestamp}</td>
                </tr>
                <tr class="extra-content">
                    <td colspan=${6}>
                        <div class="carbon-display-Regular-12">Query Prompts</div>
                        <div>${queryPrompts}</div>
                        <div><span class="carbon-display-Regular-12">Duration:</span> ${total+ ' secs' }</div>
                        <div>
                            <table class="settings-table instance-table">
                                <thead class="carbon-display-Semibold-16">
                                    <th>BOBI</th>
                                    <th>BW</th>
                                    <th>HANA</th>
                                    <th>S4 HANA</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>${value.bobi}</td>
                                        <td>${value.bw}</td>
                                        <td>${value.hana}</td>
                                        <td>${value.s4Hana}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div><a class="more-info" id=${value.id}>More details</a></div>
                    </td>
                </tr>`
            }).join('')
            var tablebody = document.getElementById(`business-anomalies ${element}`);
            table_array.push(tablebody)
            let tableData =
                `<div class="incident-tile-container">
                <table class="settings-table">
                    <thead class="carbon-display-Semibold-16">
                        <tr>
                            <th></th>
                            <th>Alert Name</th>
                            <th>Report Name</th>
                            <th>Username</th>
                            <th>Incident #</th>
                            <th>Timestamp</th>
                        </tr/>
                    </thead>
                    <tbody>
                        ${listItems}   
                    </tbody>
                </table>
                <div class="pagination-container">
                    <div class="bx--pagination">
                        <div class="bx--pagination__left">
                            <label id="bx-pagination-select-11-count-label" class="bx--pagination__text" for="bx-pagination-select-11">Items per page</label>
                            <div class="bx--form-item">
                                <div class="bx--select bx--select--inline bx--select__item-count">
                                    <div class="bx--select-input--inline__wrapper">
                                        <div class="bx--select-input__wrapper">
                                            <select id="alert-pageSize" class="bx--select-input">
                                                <option class="bx--select-option" value=${5}>5</option>
                                                <option class="bx--select-option" value=${10}>10</option>
                                                <option class="bx--select-option" value=${15}>15</option>
                                                <option class="bx--select-option" value=${20}>20</option>
                                            </select>
                                            <svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" class="bx--select__arrow" style="user-select: auto;"><path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z" style="user-select: auto;"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="bx--pagination__text bx--pagination__items-count">${alertsStartingIndex+1}–${(Number(alertsStartingIndex)+Number(pageSize-1) > alerts ? alerts.length : (Number(alertsStartingIndex)+Number(pageSize-1) > alerts.length ?  alerts.length : (Number(alertsStartingIndex)+Number(pageSize)))) +' of '+ alerts.length}</span>
                        </div>
                        <div class="bx--pagination__right">
                            <div class="bx--form-item">
                                <div class="bx--select bx--select--inline bx--select__page-number">
                                    <label for="bx-pagination-select-11-right" class="bx--label bx--visually-hidden">Page number, of 10 pages</label>
                                    <div class="bx--select-input--inline__wrapper">
                                        <div class="bx--select-input__wrapper">
                                            <select id="alert-pagination-index" class="bx--select-input">
                                            ${paginationIndexOptions}
                                                
                                            </select>
                                            <svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" class="bx--select__arrow" style="user-select: auto;"><path d="M8 11L3 6 3.7 5.3 8 9.6 12.3 5.3 13 6z" style="user-select: auto;"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="bx--pagination__text" style="user-select: auto;">of ${paginationLength} pages</span>
                            </div>
                        </div>
                    </div>
                <div>`;
            table_array.map(value => {
               value.innerHTML = `
                    <div class="overlay-container settings-container"><div class="title"><div>${DashboardConstants.Alerts}</div>
                    <div id="close-business-anomaly"><img id="close-business-anomaly" class="close" src=${Close32} /></div></div>
                   <div class="anomaly-tile">
                   ${tableData}
                   </div>`;

            })
            var pageSizeSelect = document.getElementById("alert-pageSize");
            let selectedPageSize = pageSize ? pageSize.toString() : '5';
            switch(selectedPageSize) {
                case '5':
                    pageSizeSelect && pageSizeSelect.children[0].setAttribute("selected", "selected");
                    break;
                case '10':
                    pageSizeSelect && pageSizeSelect.children[1].setAttribute("selected", "selected");
                    break;
                case '15':
                    pageSizeSelect && pageSizeSelect.children[2].setAttribute("selected", "selected");
                    break;
                case '20':
                    pageSizeSelect && pageSizeSelect.children[3].setAttribute("selected", "selected");
                    break;
                default:
                    pageSizeSelect && pageSizeSelect.children[0].setAttribute("selected", "selected");
                    break;
            }
            //to send impact, incident number, impacted KPI of incident
            let graphdata = businessArray.filter(value => value.ActivityID === element).map(function (value) {
                return ({ incidentNumber: value.IncidentNumber, value: value })
            })
            pageSizeSelect && pageSizeSelect.addEventListener('change', function(e) {
                setPageSize(e.target.value)
                setFirstRowIndex(0);
                getPaginatedRows(0, e.target.value, element);
                setSelectedNextPageIndex(defaultNextPageIndex)
              }, false);
              document.getElementById('alert-pagination-index') &&  document.getElementById('alert-pagination-index').addEventListener('change', function(e) {
                let newFirstRowIndex = pageSize * (e.target.value - 1);
                setFirstRowIndex(newFirstRowIndex);
                setSelectedNextPageIndex(e.target.value);
                getPaginatedRows(newFirstRowIndex, pageSize, element);
              }, false);
            for (let i = 0; i < graphdata.length; i++) {
                var open_incident_div = document.getElementsByClassName(`open-incident-graph-button ${graphdata[i].incidentNumber}`)

                if (open_incident_div) {
                    open_incident_div.onclick = function () {
                        //function call for hourly progression click
                        displayHourlyProgressionData(overlays, element, 'Business-Anamoly', graphdata, graphdata[i].incidentNumber);
                    }
                }
            }
            let infoButtons = document.getElementsByClassName('button-op');
            if (infoButtons.length) {
                for(let i = 0; i < infoButtons.length; i++) {
                    infoButtons[i].onclick = function () {
                        o(infoButtons[i]);
                    }
                }
            }
            let openModalLinks = document.getElementsByClassName('more-info');
            if (openModalLinks.length) {
                let sql;
                for(let i = 0; i < openModalLinks.length; i++) {
                    openModalLinks[i].onclick = function () {
                        sql = getSqlQuery(openModalLinks[i].id);
                        //function call to close business anomaly modal
                        toggleSettingsModal(sql);
                    }
                }
            }
            let close_business_anomaly = document.getElementById('close-business-anomaly');
            if (close_business_anomaly) {
                close_business_anomaly.onclick = function () {
                    //function call to close business anomaly modal
                    hideBusinessAnomalyDetails(overlays, `Business-Anamoly`);
                    setCl(null);
                    setItanomalyR([]);
                    setItanomalyA([]);
                    setOvr({});
                }
            }
        }
    }

    const setData = async (overlays, value, businessArray, Client, alertType) => {
        await setOvr(overlays);
        await setItanomalyA(businessArray)
        await setCl(Client);
        await setItanomalyR(value);
        await setAlertType(alertType);
    }

    const addSystemAlerts = (overlays, element, businessArray, Client, alertType) => {
        setAlertType(alertType);
        if (element.length > 0) {
            for (var i = 0; i < element.length; i++) {
                // attach an overlay to a node
                overlays.add(element[i].activityID, element[i].activityID, {
                    position: {
                        top: 0,
                        left: -17
                    },
                    html: `<div id="system-alert ${element[i].activityID + element[i].id}" class="settings"><img src=${ITanamoly} /></div>`
                });
            }
        }
        const handleClick = (value) => {
            setData(overlays, value, businessArray, Client, 'system');
            displaySystemAlerts(overlays, value, businessArray, Client);
        }
        element.map((value) => {
            document.getElementById(`system-alert ${value.activityID + value.id}`).onclick = () => handleClick(value.activityID);
        })
    }

    const addSettings = (overlays, element, businessArray, Client, alertType) => {
        setAlertType(alertType);
        if (element.length > 0) {
            for (var i = 0; i < element.length; i++) {
                // attach an overlay to a node
                overlays.add(element[i].activityID, element[i].activityID, {
                    position: {
                        top: 0,
                        right: -5
                    },
                    html: `<div id="business-anomalies ${element[i].activityID + element[i].id}" class="settings"><img src=${Settings} /></div>`
                });
            }
        }
        const handleClick = (value) => {
            setData(overlays, value, businessArray, Client, 'application');
        }
        element.map((value) => {
            document.getElementById(`business-anomalies ${value.activityID + value.id}`).onclick = () => handleClick(value.activityID);
        })
    }

    const addBusinessAnamoly = (overlays, element, businessArray, Client) => {
        if (element.length > 0) {
            for (var i = 0; i < element.length; i++) {
                // attach an overlay to a node
                overlays.add(element[i].activityID, element[i].activityID, {
                    position: {
                        top: 0,
                        right: -5
                    },
                    html: `<div id="business-anomaly ${element[i].activityID + element[i].id}"><img class="diagram-note" src=${BusinessAnomaly} /></div>`
                });
            }
        }
        const handleClick = (value) => {
            displayBusinessAnomalyDetails(overlays, value, businessArray, Client); //to add business anamoly table
        }
        element.map((value) => {
            document.getElementById(`business-anomaly ${value.activityID + value.id}`).onclick = () => handleClick(value.activityID);
        })
    }

    const addITAnamoly = (overlays, element, ITArray, Client) => {
        if (element.length > 0) {
            for (let i = 0; i < element.length; i++) {
                overlays.add(element[i].activityID, element[i].activityID, {
                    position: {
                        top: 3,
                        left: -18
                    },
                    html: `<div id="IT-anomaly ${element[i].activityID + element[i].id}" class="IT-anamoly"><img src=${ITanamoly} /></div>`
                });
            }
        }

        const handleClick = (value) => {
            displayITAnomalyDetails(overlays, value, ITArray, Client);  //to add IT anamoly table
        }
        element.map((value) => {
            document.getElementById(`IT-anomaly ${value.activityID + value.id}`).onclick = () => handleClick(value.activityID);
        })
    }

    const displayBusinessAnomalyDetails = (overlays, element, businessArray, Client) => {

        overlays.remove({ type: `IT-Anamolies` })
        overlays.remove({ type: `Business-Anamoly` })
        overlays.remove({ type: `Incident-Hourly-Progression` })
        var table_array = []
        if (element) {
            //to add right arrow
            overlays.add(element, `Business-Anamoly`, {
                position: {
                    top: -2,
                    right: -20
                },
                html: `<div><img class="right-arrow" src=${ChevronRight} /></div>`
            });
            //to add div for table
            overlays.add(element, `Business-Anamoly`, {
                position: {
                    top: -140,
                    right: -40
                },
                html: `
              <body><div>
              <div class="business-anomalies ${element}" id="business-anomalies ${element}"></div>
              </div></body>  `
            });
            var tablebody = document.getElementById(`business-anomalies ${element}`);
            table_array.push(tablebody)
            let tableData = businessArray.filter(value => value.ActivityID === element).map(function (value) {
                let incidentpath = `/IncidentDetails?alertType=alert&client=${Client}&incidentId=${value.IncidentNumber}&sysId=${value.IncidentSysId}&workspace=${workspaces.sap_ops}`
                return (`<div class="incident-tile-container">
                <div class="alert-header"><div class="alert-name">
                <div class=${SummaryDropdown === "orderToCashV1" ? "icon-top" : "icon"}><img class=${SummaryDropdown === "orderToCashV1" ? "warning" : "weather"} src=${SummaryDropdown === "orderToCashV1" ? Warning : WeatherIcon} /></div>
                <div class="name-incident-container"><div class="name">${value.AlertName}</div><div>
                <div class=${SummaryDropdown === "orderToCashV1" ? "alert-incident-number" : "alert-incident-number-left"} ><a href=${incidentpath} target="_blank" >${value.IncidentNumber}</a><div class="alert-time">${moment(new Date(value.AlertTime)).format("HH:mm | Do MMM YY")}</div>
                </div></div></div></div>
                <div class="status"><div class="alert-incident-status">${value.Status}</div><a href=${incidentpath} target="_blank"><img class="right-arrow" src=${ChevronRight} /></a></div></div>
                <div class="alert-table">
                <div class="alert-row"><div class="key">Count</div><div class="value"> ${value.Count}</div></div>
                <div class="alert-row impacted-kpi"><div class="key">Impacted KPI</div><div class="value">${value.ImpactedKPI}</div></div>
                <div class="alert-row"><div class="key impact">Impact<button id="open-incident-graph-button ${value.IncidentNumber}" class="alert-hourly-view"><div>View hourly projections </div><div><img class="time" src=${Time}> </div></button> </div>  
                <div class="value">${value.Impact}</div></div>                 
                </div> </div>`);
            }).join('');
            table_array.map(value => {
                value.innerHTML = `
                    <div class="overlay-container"><div class="title"><div>${DashboardConstants.BusinessAnomalies}</div>
                    <div id="close-business-anomaly"><img id="close-business-anomaly" class="close" src=${Close32} /></div></div>
                   <div class="anomaly-tile">
                   ${tableData}
                   </div>`;
            })
            //to send impact, incident number, impacted KPI of incident
            let graphdata = businessArray.filter(value => value.ActivityID === element).map(function (value) {
                return ({ incidentNumber: value.IncidentNumber, value: value })
            })


            for (let i = 0; i < graphdata.length; i++) {
                var open_incident_div = document.getElementById(`open-incident-graph-button ${graphdata[i].incidentNumber}`)

                if (open_incident_div) {
                    open_incident_div.onclick = function () {
                        //function call for hourly progression click
                        displayHourlyProgressionData(overlays, element, 'Business-Anamoly', graphdata, graphdata[i].incidentNumber);
                    }
                }
            }

            let close_business_anomaly = document.getElementById('close-business-anomaly');
            if (close_business_anomaly) {
                close_business_anomaly.onclick = function () {
                    //function call to close business anomaly modal
                    hideBusinessAnomalyDetails(overlays, `Business-Anamoly`);
                }
            }
        }
    }

    const displayHourlyProgressionData = (overlays, element, type, graphdata, IncidentNumber) => {

        overlays.remove({ type: `Incident-Hourly-Progression` })
        //get values of selected incident
        let selectedIncidentData = graphdata.filter(value => value.incidentNumber === IncidentNumber)
        //let impactedKPI = selectedIncidentData[0].value.ImpactedKPI
        let impactkey = selectedIncidentData[0].value.ImpactKpiThroughput && Object.keys(selectedIncidentData[0].value.ImpactKpiThroughput).length !== 0 ? Object.keys(selectedIncidentData[0].value.ImpactKpiThroughput.impact) : [];
        let throughputkey = selectedIncidentData[0].value.ImpactKpiThroughput && Object.keys(selectedIncidentData[0].value.ImpactKpiThroughput).length !== 0 ? Object.keys(selectedIncidentData[0].value.ImpactKpiThroughput.throughput) : [];
        // let salesDocumentThroughputvalue = (throughputSalesDocument[throughputSalesDocumentObjectkeys[0]] - impactSalesDocument[throughputSalesDocumentObjectkeys[0]]).toFixed(2)
        // let salesInvoicesThroughputvalue = (throughputSalesInvoice[throughputSalesDocumentObjectkeys[0]] - impactSalesInvoice[throughputSalesDocumentObjectkeys[0]]).toFixed(2)
        // let ImpactedKPIValue = salesInvoicesThroughputvalue > salesDocumentThroughputvalue ? "Revenue Booked Sales Orders / day" : "Sales Orders Intake / day";

        let topvalue = -140, rightvalue = 0
        if (type === "Business-Anamoly") {
            rightvalue = -40;
        }
        else {
            rightvalue = 567;
        }
        let graphThroughtput; let graphImpact; let throughputSalesDocumentObjectkeys; let impactSalesDocumentObjectkeys;

        if (impactkey.length > 0 && throughputkey.length > 0) {
            graphThroughtput = selectedIncidentData[0].value.ImpactKpiThroughput.throughput[throughputkey[0]]
            graphImpact = selectedIncidentData[0].value.ImpactKpiThroughput.impact[impactkey[0]]
            throughputSalesDocumentObjectkeys = Object.keys(graphThroughtput).sort();
            impactSalesDocumentObjectkeys = Object.keys(graphImpact).sort();
        }
        else {
            graphThroughtput = null;
            graphImpact = null;
            throughputSalesDocumentObjectkeys = null;
        }
        let KPITrendkeys = 0;
        let KpiTrend = selectedIncidentData[0].value.ImpactKpiThroughput && selectedIncidentData[0].value.ImpactKpiThroughput.kpi_history ? selectedIncidentData[0].value.ImpactKpiThroughput.kpi_history : {};
        KPITrendkeys = Object.keys(KpiTrend).sort();
        let impact1 = graphImpact && graphImpact[impactSalesDocumentObjectkeys[0]] !== null ? graphImpact[impactSalesDocumentObjectkeys[0]].toFixed(2) : 0;
        let throughput1 = graphThroughtput && graphThroughtput[throughputSalesDocumentObjectkeys[0]] !== null ? graphThroughtput[throughputSalesDocumentObjectkeys[0]].toFixed(2) : 0;

        let impact2 = graphImpact && graphImpact[impactSalesDocumentObjectkeys[3]] !== null ? graphImpact[impactSalesDocumentObjectkeys[3]].toFixed(2) : 0;
        let throughput2 = graphThroughtput && graphThroughtput[throughputSalesDocumentObjectkeys[2]] !== null ? graphThroughtput[throughputSalesDocumentObjectkeys[3]].toFixed(2) : 0;

        let impact3 = graphImpact && graphImpact[impactSalesDocumentObjectkeys[6]] !== null ? graphImpact[impactSalesDocumentObjectkeys[6]].toFixed(2) : 0;
        let throughput3 = graphThroughtput && graphThroughtput[throughputSalesDocumentObjectkeys[5]] !== null ? graphThroughtput[throughputSalesDocumentObjectkeys[6]].toFixed(2) : 0;

        let impact4 = graphImpact && graphImpact[impactSalesDocumentObjectkeys[9]] !== null ? graphImpact[impactSalesDocumentObjectkeys[9]].toFixed(2) : 0;
        let throughput4 = graphThroughtput && graphThroughtput[throughputSalesDocumentObjectkeys[8]] !== null ? graphThroughtput[throughputSalesDocumentObjectkeys[9]].toFixed(2) : 0;

        let impact5 = graphImpact && graphImpact[impactSalesDocumentObjectkeys[12]] !== null ? graphImpact[impactSalesDocumentObjectkeys[12]].toFixed(2) : 0;
        let throughput5 = graphThroughtput && graphThroughtput[throughputSalesDocumentObjectkeys[11]] !== null ? graphThroughtput[throughputSalesDocumentObjectkeys[12]].toFixed(2) : 0;
        let KpiTrend1 = KpiTrend[KPITrendkeys[13]];
        let KpiTrend2 = KpiTrend[KPITrendkeys[16]];
        let KpiTrend3 = KpiTrend[KPITrendkeys[19]];
        let KpiTrend4 = KpiTrend[KPITrendkeys[22]];
        overlays.add(element, `Incident-Hourly-Progression`, {
            position: {
                top: topvalue,
                right: rightvalue,
            },
            html: `<div class="incident-container">
            <div class="graph-header" ><div class="title"><img class="left-arrow" id="back-incident"  src=${LeftArrow} />Hourly projections</div>
            <div id="close-incident"><img id="close-incident" class="close" src=${Close32} /></div></div>
            <div id="line-chart" class="line-chart" style="width: 100%; height: 100%;"></div>
            <div class="key-container">
            <div class="key-rows"> <div class="key-value"><div class="key">Hours</div><div class="value">Impact</div></div>
            <div class="key-value grey"><div class="key">${"+00:00"}</div><div class="value">${(throughput1 - impact1) > 0 ? (throughput1 - impact1).toFixed(1) : 0}</div></div>
            <div class="key-value"><div class="key">${"+00:15"}</div><div class="value">${(throughput2 - impact2) > 0 ? (throughput2 - impact2).toFixed(1) : 0}</div></div>
            <div class="key-value grey"><div class="key">${"+00:30"}</div><div class="value">${(throughput3 - impact3) > 0 ? (throughput3 - impact3).toFixed(1) : 0}</div></div>
            <div class="key-value "><div class="key">${"+00:45"}</div><div class="value">${(throughput4 - impact4) > 0 ? (throughput4 - impact4).toFixed(1) : 0}</div></div>
            <div class="key-value grey"><div class="key">${"+01:00"}</div><div class="value">${(throughput5 - impact5) > 0 ? (throughput5 - impact5).toFixed(1) : 0}</div></div>
            </div> </div></div>`
        });

        let backincident = document.getElementById('back-incident');
        let closeincident = document.getElementById('close-incident');

        if (backincident) {
            backincident.onclick = function () {
                hideHourlyProgressionDetails(overlays, `Incident-Hourly-Progression`, "back");
            }
        }
        if (closeincident) {
            closeincident.onclick = function () {
                hideHourlyProgressionDetails(overlays, `Incident-Hourly-Progression`, "close");
            }
        }

        const data = [];
        KPITrendkeys && KPITrendkeys.length > 0 && data.push({
            "group": "KPI trend",
            "hours": "-01:00",
            "value": KpiTrend1 ? KpiTrend1 : null,
        },
            {
                "group": "KPI trend",
                "hours": "-00:45",
                "value": KpiTrend2 ? KpiTrend2 : null,
            },
            {
                "group": "KPI trend",
                "hours": "-00:30",
                "value": KpiTrend3 ? KpiTrend3 : null,
            },
            {
                "group": "KPI trend",
                "hours": "-00:15",
                "value": KpiTrend4 ? KpiTrend4 : null,
            },
            {
                "group": "KPI trend",
                "hours": "+00:00",
                "value": KpiTrend4 && impact1 ? impact1 : null,
            })

        data.push(
            {
                "group": "w/o anomaly",
                "hours": "+00:00",
                "value": throughput1,
            },
            {
                "group": "w/o anomaly",
                "hours": "+00:15",
                "value": throughput2,
            },
            {
                "group": "w/o anomaly",
                "hours": "+00:30",
                "value": throughput3,
            },
            {
                "group": "w/o anomaly",
                "hours": "+00:45",
                "value": throughput4,
            },
            {
                "group": "w/o anomaly",
                "hours": "+01:00",
                "value": throughput5,
            },
            {
                "group": "with anomaly",
                "hours": "+00:00",
                "value": impact1,
            },
            {
                "group": "with anomaly",
                "hours": "+00:15",
                "value": impact2,
            },
            {
                "group": "with anomaly",
                "hours": "+00:30",
                "value": impact3,
            },
            {
                "group": "with anomaly",
                "hours": "+00:45",
                "value": impact4,
            },
            {
                "group": "with anomaly",
                "hours": "+01:00",
                "value": impact5,
            }
        );

        const options = {
            animations: true,
            resizable: false,
            color: {
                scale: {
                    'KPI trend': '#0e751a',
                    //'with anomaly': '#Af0909',
                    //'w/o anomaly': '#1b479e',
                },
            },
            axes: {
                bottom: {
                    "title": "Hours",
                    mapsTo: "hours",
                    scaleType: "labels",
                    includeZero: false,
                    // thresholds: [
                    //   {
                    //     value: "+03:00",
                    //     label: "MTTR",
                    //     fillColor: "grey",
                    //   }
                    // ]
                },
                left: {
                    "title": "Orders",
                    mapsTo: "value",
                    scaleType: "linear",
                    includeZero: false,
                    ticks: {
                        number: 12,
                        min: 10,
                    }
                }
            },
            height: "310px",
            toolbar: {
                enabled: false,
            },
        }

        const chartHolder = document.getElementById("line-chart");
        new LineChart(chartHolder, {
            data,
            options
        });
    }

    const hideBusinessAnomalyDetails = (overlays, type) => {
        //remove business anomaly modal
        setFirstRowIndex(defaultFirstRowIndex);
        // setPageSize(defaultCurrentPageSize);
        overlays.remove({ type: type });
    };

    const hideHourlyProgressionDetails = (overlays, type, closetype) => {
        //remove Hourly Progression Details
        if (closetype === "back") {
            overlays.remove({ type: type });
        }
        else if (closetype === "close") {
            overlays.remove({ type: type });
            overlays.remove({ type: `Business-Anamoly` })
            overlays.remove({ type: `IT-Anamolies` })
        }
    };


    const displayITAnomalyDetails = (overlays, element, ITArray, Client) => {
        overlays.remove({ type: `Business-Anamoly` })
        overlays.remove({ type: `IT-Anamolies` })
        overlays.remove({ type: `Incident-Hourly-Progression` })
        var table_array = []
        if (element) {
            //add left arrow
            overlays.add(element, `IT-Anamolies`, {
                position: {
                    top: 0,
                    left: -38
                },
                html: `<div><img class="right-arrow" src=${ChevronLeft} /></div>`
            });
            //add IT anamoly table data
            overlays.add(element, `IT-Anamolies`, {
                position: {
                    top: -140,
                    left: -467
                },
                html: `<div class="business-anomalies ${element}" id="IT-anomalies ${element}"></div>`
            });
            var ITAnomalyContainer = document.getElementById(`IT-anomalies ${element}`);
            table_array.push(ITAnomalyContainer)
            table_array.map(value => {
                value.innerHTML = `<div class="overlay-container"><div class="title"><div>${DashboardConstants.ITAnomalies}</div>
                <div id="close-IT-anomaly"><img id="close-IT-anomaly" class="close" src=${Close32} /></div></div>
                <div class="server-container"><div class="server-icon" id="server-icon">
                </div></div>
                <div id="IT-anomalies-table" class="anomaly-tile">
                </div>
                </div>`;
            })
            let graphdata = ITArray.filter(value => value.ActivityID === element).map(function (value) {
                return ({ incidentNumber: value.IncidentNumber, value: value })
            })

            //sets the default result when IT anamoly Table is clicked
            let serverContainer = document.getElementById('server-icon');
            let ServerDataArray = [...new Set(ITArray.filter(value => value.ActivityID === element).map((value) => value.Entity))]
            let ServerData = ServerDataArray.map(function (value, i) {
                return (
                    `<div class="server" id="server" tabindex="${i}"><div class="serverimage"><img  tabindex="${i}"  id="${value.replace(/ /g, "")}" src=${Database} /><div class="text">${value}</div></div></div>`
                );
            }).join('');
            serverContainer.innerHTML = `${ServerData}`
            let ITanomalies = document.getElementById('IT-anomalies-table');
            let defaultresult = ITArray.filter(defaultvalue => defaultvalue.Entity === ServerDataArray[0]).filter(value => value.ActivityID === element)
            for (let r = 0; r < defaultresult.length; r++) {

                let incidentpath = `/IncidentDetails?alertType=alert&client=${Client}&incidentId=${defaultresult[r].IncidentNumber}&sysId=${defaultresult[r].IncidentSysId}&workspace=${workspaces.sap_ops}`
                ITanomalies.innerHTML += `<div class="incident-tile-container">	
                <div class="alert-header"><div class="alert-name"> 
                <div class="icon-top"><img class="warning" src=${Warning} /></div>
                <div class="name-incident-container"> <div class="name">${defaultresult[r].AlertName}</div>
                <div><div  class="alert-incident-number"><a href=${incidentpath} target="_blank">${defaultresult[r].IncidentNumber}</a>
                <div class="alert-time">${moment(new Date(defaultresult[r].AlertTime)).format("HH:mm | Do MMM YY")}</div></div></div></div></div>
                <div class="status"><div class="alert-incident-status">${defaultresult[r].Status}
                </div> <a href=${incidentpath} target="_blank" ><img class="right-arrow" src=${ChevronRight} /> </a></div></div>
                <div class="alert-table"><div class="alert-row"><div class="key">Count</div> <div class="value"> ${defaultresult[r].Count}</div></div>
                <div class="alert-row impacted-kpi"><div class="key" >Impacted KPI</div><div class="value"> ${defaultresult[r].ImpactedKPI}</div></div>
                <div class="alert-row"><div class="key impact">Impact 
                <button id="open-incident-graph-button ${defaultresult[r].IncidentNumber}" class="alert-hourly-view"><div>View hourly projections </div>
                <div><img class="time" src=${Time}> </div> </button> </div> <div class="value">${defaultresult[r].Impact}</div></div></div></div>`
            }
            //window.location.hash = '#server';
            //sets the result when IT anamoly Server Icon is clicked for the selected server
            $(function () {
                $('img[tabindex="0"]').addClass("selected-server");
                $("img").click(function () {
                    // remove classes from all
                    $("img").removeClass("selected-server");
                    // add class to the one we clicked
                    $(this).addClass("selected-server");
                });
            });

            ServerDataArray.map(function (value, i) {
                if (document.getElementById(`${value.replace(/ /g, "")}`)) {
                    document.getElementById(`${value.replace(/ /g, "")}`).onclick = function () {
                        let result = ITArray.filter(value1 => value1.Entity === value).filter(value => value.ActivityID === element)
                        ITanomalies.innerHTML = "";
                        for (let c = 0; c < result.length; c++) {
                            let incidentpath = `/IncidentDetails?alertType=alert&client=${Client}&incidentId=${result[c].IncidentNumber}&sysId=${result[c].IncidentSysId}&workspace=${workspaces.sap_ops}`
                            ITanomalies.innerHTML += `<div class="incident-tile-container">	
                            <div class="alert-header"><div class="alert-name"> 
                            <div class="icon-top"><img class="warning" src=${Warning} /></div>
                            <div class="name-incident-container"> <div class="name">${result[c].AlertName}</div>
                            <div><div  class="alert-incident-number"><a href=${incidentpath} target="_blank">${result[c].IncidentNumber}</a>
                            <div class="alert-time">${moment(new Date(result[c].AlertTime)).format("HH:mm | Do MMM YY")}</div></div></div></div></div>
                            <div class="status"><div class="alert-incident-status">${result[c].Status}
                            </div> <a href=${incidentpath} target="_blank" ><img class="right-arrow" src=${ChevronRight} /> </a></div></div>
                            <div class="alert-table"><div class="alert-row"><div class="key">Count</div> <div class="value"> ${result[c].Count}</div></div>
                            <div class="alert-row impacted-kpi"><div class="key" >Impacted KPI</div><div class="value"> ${result[c].ImpactedKPI}</div></div>
                            <div class="alert-row"><div class="key impact">Impact 
                            <button id="open-incident-graph-button ${result[c].IncidentNumber}" class="alert-hourly-view"><div>View hourly projections </div>
                            <div><img class="time" src=${Time}> </div> </button> </div> <div class="value">${result[c].Impact}</div></div></div></div>`
                        }
                        for (let i = 0; i < graphdata.length; i++) {
                            var open_incident_div = document.getElementById(`open-incident-graph-button ${graphdata[i].incidentNumber}`)
                            if (open_incident_div) {
                                open_incident_div.onclick = function () {
                                    //sends data for Hourly Progression
                                    displayHourlyProgressionData(overlays, element, 'IT-Anamolies', graphdata, graphdata[i].incidentNumber);
                                }
                            }
                        }
                    }
                }
            })

            let close_IT_anomaly = document.getElementById('close-IT-anomaly');
            if (close_IT_anomaly) {
                close_IT_anomaly.onclick = function () {
                    hideITAnomalyDetails(overlays, `IT-Anamolies`);
                }
            };

            for (let i = 0; i < graphdata.length; i++) {
                var open_incident_div = document.getElementById(`open-incident-graph-button ${graphdata[i].incidentNumber}`)
                if (open_incident_div) {
                    open_incident_div.onclick = function () {
                        //sends data for Hourly Progression
                        displayHourlyProgressionData(overlays, element, 'IT-Anamolies', graphdata, graphdata[i].incidentNumber);
                    }
                }
            }
        }
    }

    const hideITAnomalyDetails = (overlays, type) => {
        //remove IT anomaly modal
        overlays.remove({ type: type });
    };



    function toggleFullScreen() {
        if (!document.getElementById('bpmnContainer').fullscreenElement) {
            document.getElementById('bpmnContainer').requestFullscreen();
            document.getElementById('bpmnContainer').style.background = "white"
        } else {
            if (document.getElementById('bpmnContainer').exitFullscreen) {
                document.getElementById('bpmnContainer').exitFullscreen();
            }
        }
    }

    function handleSummaryDropdownValue(name) {
        setSummaryDropdown(name);
    }

    const items = [
        {
            id: 'FinanceReporting',
            text: DashboardConstants.FinanceReporting,
        },
        {
            id: 'orderToCash',
            text: DashboardConstants.OrderToCash
        },
        {
            id: 'orderToCashV1',
            text: DashboardConstants.OrderToCashV1,
        }
    ];

    return (
        <div className="top-margin dashboard process-excellence">
            <Modal
				passiveModal
				open={showSettingsModal}
				onRequestClose={toggleSettingsModal}
				onRequestSubmit={toggleSettingsModal}
			>
				<div className="settings-modal">
                    <header className="carbon-display-Semibold-16">Remote Statement Queries:</header>
                    <BpmnTableComponent isExpandable={false} size="md" loading={false} tablePaginationLimit={7} defaultCurrentPageSize={7}
                        rows={sqlQueriesData}
                        headers={mockSettingsData.sqlTableHeaders} itemsPerPageText={DashboardConstants.Itemspage} showPagination={true}
                    />
                </div>
			</Modal>
            <div className="dashboard-detail-container col-lg-12 no-gutters">
                <div className="dashboard-roleContainer">
                    <BpmnSummary timeFilterSelections={props.timeFilterSelections} impactArray={impactArray} setSalesOrderBookedValue={setSalesOrderBookedValue}
                    setSalesOrderIntakeValue={setSalesOrderIntakeValue} handleSummaryDropdownValue={handleSummaryDropdownValue} SummaryDropdown={SummaryDropdown} alerts={alertType === 'application' ? applicationAlerts : systemAlerts} alertType = {alertType}/>
                </div>
                <div className="sidenav-container">
                    <div className="side-nav">
                        <BPMNSideNav SummaryDropdown={SummaryDropdown} handleSummaryDropdownValue={handleSummaryDropdownValue} />
                    </div>
                <div className="dashboard-charts-container">
                    <div className="report-title">
                        <div>{items.length > 0 && items.filter((item) => { return item.id === SummaryDropdown }).map(value => value.text)}</div>
                    </div>
                    <div className="buttons">
                        <div className="bpmn-button">
                            <button><Add32 id="btnzoomin" class="btnzoomin" /></button>
                            <button><Reset32 id="btnzoomreset" class="btnzoomreset" /></button>
                            <button><Subtract32 id="btnzoomout" class="btnzoomout" /></button>
                            <button><Maximize32 onClick={() => toggleFullScreen()} /></button>
                        </div>
                    </div>
                    <section className="border-bottom">
                        <div id="bpmnContainer" class={SummaryDropdown === "orderToCash" ? "bpmnContainer cox-height" : "bpmnContainer"}>
                        {loader === true ? <div className="loader"><InlineLoading description={DashboardConstants.Loading} /></div> : ""}
                        </div>
                    </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BpmnDiagram;
